import { encryptStorage } from './storage';

export const SEEN_IDS_STORAGE_KEY = 'whatsNewSeenIds';

const ticketNumber = (entry) =>
  parseInt(String(entry.ticket ?? '').replace(/\D/g, ''), 10) || 0;

// Merge any number of entry lists into one feed: dedupe by id (first list
// wins), newest-first by date, ticket number breaking same-date ties.
export function mergeEntries(...lists) {
  const byId = new Map();

  lists.flat().forEach((entry) => {
    if (entry?.id && !byId.has(entry.id)) byId.set(entry.id, entry);
  });

  return [...byId.values()].sort(
    (a, b) =>
      String(b.date).localeCompare(String(a.date)) ||
      ticketNumber(b) - ticketNumber(a),
  );
}

export function getSeenIds() {
  const stored = encryptStorage.getItem(SEEN_IDS_STORAGE_KEY);

  return Array.isArray(stored) ? stored : [];
}

// Seen ids accumulate (union) so entries temporarily missing from the feed —
// e.g. the API half failing to load — don't reappear as "new" once seen.
export function saveSeenIds(previousIds, entries) {
  const merged = [...new Set([...previousIds, ...entries.map((e) => e.id)])];

  encryptStorage.setItem(SEEN_IDS_STORAGE_KEY, merged);

  return merged;
}

export function countUnseen(entries, seenIds) {
  const seen = new Set(seenIds);

  return entries.filter((entry) => !seen.has(entry.id)).length;
}
